import React, { useEffect } from "react";
import { CURRENT_COUNTRY } from "utils/constants";
import { Script } from "gatsby";

const chatId = {
	"de": "01GYCC18M342G2VRGK1V9T1WFH",
	"nl": "01GYCCSF4J61A762GC1648FCNN",
	"ch": "01J4V77PR3P7B129H8686WGJ0G"
};

const GorgiasChat = ({ pageType, hasProductSingle, path }) => {
	const widgetId = chatId[CURRENT_COUNTRY];

	useEffect(() => {
		const initGorgiasChatPromise = (
			window.GorgiasChat) ? window.GorgiasChat.init() :
			new Promise(function (resolve) {
				window.addEventListener("gorgias-widget-loaded", function () { resolve(); });
			});

		// Hide chat on all pages except FAQ Account
		initGorgiasChatPromise.then(async () => {
			window.GorgiasChat?.hideChat(true);
		});
		if (path?.includes("faq-account")) {
			const isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;
			initGorgiasChatPromise.then(async () => {
				window.GorgiasChat?.hideChat(false);
			});
			if (isMobile) {
				const checkChatElem = setInterval(() => {
					const chatElem = document.getElementById("chat-button");
					if (chatElem) {
						clearInterval(checkChatElem);
						chatElem.style.position = "fixed";
						let bottomPosition;

						if (hasProductSingle)
							bottomPosition = "140px";
						else if (pageType === "collection")
							bottomPosition = "20px";
						else if (pageType === "subscription")
							bottomPosition = "70px";
						else
							bottomPosition = "20px";

						chatElem.style.bottom = bottomPosition;
					}
				}, 300);
			}
		}
	}, [path]);

	return <Script id="gorgias-chat-widget-install-v3" src={`https://config.gorgias.chat/bundle-loader/${widgetId}`} />;
};

export default GorgiasChat;
